var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2496 5.35962C54.2496 2.46012 51.8991 0.109619 48.9996 0.109619C46.1001 0.109619 43.7496 2.46012 43.7496 5.35962V13.9222C28.3655 16.2041 16.2031 28.366 13.9205 43.7498H5.35938C2.45988 43.7498 0.109375 46.1003 0.109375 48.9998C0.109375 51.8993 2.45988 54.2498 5.35938 54.2498H13.9208C16.2039 69.6329 28.366 81.7941 43.7496 84.0759V92.6398C43.7496 95.5393 46.1001 97.8898 48.9996 97.8898C51.8991 97.8898 54.2496 95.5393 54.2496 92.6398V84.0751C69.6308 81.7915 81.7905 69.6313 84.0734 54.2498H92.6421C95.5416 54.2498 97.8921 51.8993 97.8921 48.9998C97.8921 46.1003 95.5416 43.7498 92.6421 43.7498H84.0737C81.7913 28.3676 69.6313 16.2067 54.2496 13.923V5.35962ZM24.0371 48.9998C24.0371 49.0482 24.0364 49.0964 24.0351 49.1445C24.1134 62.8639 35.2593 73.9614 48.9971 73.9614C62.7835 73.9614 73.9595 62.7854 73.9595 48.9991C73.9595 35.2389 62.8258 24.0791 49.0756 24.0368C49.0503 24.0372 49.0249 24.0373 48.9996 24.0373C48.9739 24.0373 48.9483 24.0372 48.9227 24.0368C35.2186 24.0768 24.1126 35.1597 24.0351 48.8549C24.0364 48.9031 24.0371 48.9514 24.0371 48.9998ZM40.3859 48.9992C40.3859 44.2445 44.2403 40.39 48.995 40.39C53.7497 40.39 57.6041 44.2445 57.6041 48.9992C57.6041 53.7539 53.7497 57.6083 48.995 57.6083C44.2403 57.6083 40.3859 53.7539 40.3859 48.9992Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.a15f80e59a9bfab42b6ff13376a518ff.svg";
export { ForwardRef as ReactComponent };